module.exports = __webpack_public_path__ + "img/1.6ad06c78.png";